import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { Skeleton } from '@/components/ui/skeleton';
import React from 'react';
import { FieldComponentProps } from './types';

type Option = {
  value: string;
  label: string;
};

const FieldView = ({
  value,
  options,
}: {
  value?: string | null;
  options: Option[];
}) => {
  if (value === null || value === undefined || value === '') {
    return <p className="text-muted-foreground">-</p>;
  }
  const selectedOption = options.find((opt) => opt.value === value);
  return <p>{selectedOption?.label || String(value)}</p>;
};

export const SelectField: React.FC<FieldComponentProps> = ({
  formMode,
  controllerField,
  field,
}) => {
  if (formMode === 'loading') {
    return <Skeleton className="h-8 w-full" />;
  }

  if (formMode === 'edit') {
    return (
      <Select
        onValueChange={controllerField.onChange}
        defaultValue={controllerField.value}
      >
        <SelectTrigger size="sm">
          <SelectValue placeholder={field.meta.placeholder} />
        </SelectTrigger>
        <SelectContent>
          {field.meta.options?.map((option) => (
            <SelectItem key={option.value} value={option.value}>
              {option.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    );
  }

  return (
    <FieldView
      value={controllerField.value}
      options={field.meta.options || []}
    />
  );
};
